
    <h3 class="mat-dialog-title">
      Prebid config parameters
    </h3>
    <mat-dialog-content>
      <div *ngFor="let config of configs" class=" mb-2">
        <mat-form-field class="w-100">
          <textarea matInput matTextareaAutosize rows="6" [placeholder]="getPlaceholderFromConfig(config)"
                    [value]="getUserFriendlyConfig(config)" readonly class="textarea-note">
          </textarea>
        </mat-form-field>
      </div>
      <div *ngIf="configs.length === 0">
        <p><i class="far fa-frown" aria-hidden="true"></i> We are sorry but there are no active configurations at this moment.</p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="primary" *ngIf="configs.length != 0" (click)="onDownloadFile()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-download"></i>
        <span>Download file</span>
      </button>
      <button mat-raised-button color="primary" *ngIf="configs.length != 0" (click)="copyToClipboard()" class="iconed mb-3 mb-sm-0">
        <i class="fas fa-clipboard"></i>
        <span>Copy all to clipboard</span>
      </button>
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  